/**
 * 站点品牌配置：改这里即可全局同步产品名。
 * 与 C 端 `layer-weaver-client/src/config/site.ts` 保持一致。
 */
export const site = {
    /** 对外产品名 */
    name: 'NeissAI',
    /** 管理后台标题 */
    adminTitle: 'NeissAI 管理后台',
} as const

export type SiteConfig = typeof site
